'use client';

import { DiningIcon } from './AcademicIcons';
import type { ComponentType, SVGProps } from 'react';
import {
  AcademicCapIcon,
  ArrowDownTrayIcon,
  ArrowPathIcon,
  ArrowRightIcon,
  ArrowTopRightOnSquareIcon,
  BeakerIcon,
  CalculatorIcon,
  BoltIcon,
  BookOpenIcon,
  BriefcaseIcon,
  BuildingOffice2Icon,
  CakeIcon,
  CalendarDaysIcon,
  CheckCircleIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ClockIcon,
  CloudIcon,
  CodeBracketIcon,
  ComputerDesktopIcon,
  CpuChipIcon,
  CubeIcon,
  CurrencyDollarIcon,
  CursorArrowRaysIcon,
  ExclamationCircleIcon,
  FireIcon,
  FunnelIcon,
  GlobeAltIcon,
  HeartIcon,
  HomeIcon,
  InformationCircleIcon,
  ListBulletIcon,
  MagnifyingGlassIcon,
  MapIcon,
  MapPinIcon,
  NoSymbolIcon,
  PhoneIcon,
  ScaleIcon,
  ShareIcon,
  ShieldCheckIcon,
  SignalIcon,
  SparklesIcon,
  StarIcon,
  SunIcon,
  TicketIcon,
  TruckIcon,
  UserGroupIcon,
  XCircleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

type IconProps = SVGProps<SVGSVGElement> & {
  size?: number | string;
  strokeWidth?: number | string;
};

function createIcon(Icon: ComponentType<SVGProps<SVGSVGElement>>) {
  function HeroIconAdapter({ size, style, strokeWidth: _strokeWidth, ...props }: IconProps) {
    const dimensionStyle =
      size == null
        ? style
        : {
            width: typeof size === 'number' ? `${size}px` : size,
            height: typeof size === 'number' ? `${size}px` : size,
            ...style,
          };

    return <Icon aria-hidden {...props} style={dimensionStyle} />;
  }

  return HeroIconAdapter;
}

export const Activity = createIcon(BoltIcon);
export const AlertCircle = createIcon(ExclamationCircleIcon);
export const ArrowRight = createIcon(ArrowRightIcon);
export const ArrowUpRight = createIcon(ArrowTopRightOnSquareIcon);
export const Ban = createIcon(NoSymbolIcon);
export const BookOpen = createIcon(BookOpenIcon);
export const Bot = createIcon(CpuChipIcon);
export const BrainCircuit = createIcon(CpuChipIcon);
export const Briefcase = createIcon(BriefcaseIcon);
export const Building = createIcon(BuildingOffice2Icon);
export const Bus = createIcon(TruckIcon);
export const Calendar = createIcon(CalendarDaysIcon);
export const CalendarCheck2 = createIcon(CalendarDaysIcon);
export const CalendarDays = createIcon(CalendarDaysIcon);
export const CalendarSearch = createIcon(CalendarDaysIcon);
export const Calculator = createIcon(CalculatorIcon);
export const Car = createIcon(TruckIcon);
export const CarFront = createIcon(TruckIcon);
export const CheckCircle = createIcon(CheckCircleIcon);
export const CheckCircle2 = createIcon(CheckCircleIcon);
export const ChevronDown = createIcon(ChevronDownIcon);
export const ChevronLeft = createIcon(ChevronLeftIcon);
export const ChevronRight = createIcon(ChevronRightIcon);
export const Clock = createIcon(ClockIcon);
export const CloudRain = createIcon(CloudIcon);
export const Code2 = createIcon(CodeBracketIcon);
export const Coffee = createIcon(CakeIcon);
export const Crosshair = createIcon(CursorArrowRaysIcon);
export const Dice5 = createIcon(CubeIcon);
export const DollarSign = createIcon(CurrencyDollarIcon);
export const DoorOpen = createIcon(BuildingOffice2Icon);
export const Download = createIcon(ArrowDownTrayIcon);
export const ExternalLink = createIcon(ArrowTopRightOnSquareIcon);
export const Filter = createIcon(FunnelIcon);
export const Flame = createIcon(FireIcon);
export const Globe = createIcon(GlobeAltIcon);
export const GraduationCap = createIcon(AcademicCapIcon);
export const Heart = createIcon(HeartIcon);
export const Home = createIcon(HomeIcon);
export const Info = createIcon(InformationCircleIcon);
export const Laptop = createIcon(ComputerDesktopIcon);
export const Leaf = createIcon(SparklesIcon);
export const List = createIcon(ListBulletIcon);
export const Loader2 = createIcon(ArrowPathIcon);
export const MapPin = createIcon(MapPinIcon);
export const Navigation = createIcon(CursorArrowRaysIcon);
export const Phone = createIcon(PhoneIcon);
export const RefreshCw = createIcon(ArrowPathIcon);
export const Route = createIcon(MapIcon);
export const Scale = createIcon(ScaleIcon);
export const Search = createIcon(MagnifyingGlassIcon);
export const Share2 = createIcon(ShareIcon);
export const ShieldCheck = createIcon(ShieldCheckIcon);
export const Sparkles = createIcon(SparklesIcon);
export const Star = createIcon(StarIcon);
export const Stethoscope = createIcon(HeartIcon);
export const Sun = createIcon(SunIcon);
export const Ticket = createIcon(TicketIcon);
export const TimerReset = createIcon(ClockIcon);
export const Utensils = createIcon(DiningIcon);
export const UtensilsCrossed = createIcon(DiningIcon);
export const Users = createIcon(UserGroupIcon);
export const Wifi = createIcon(SignalIcon);
export const WifiOff = createIcon(NoSymbolIcon);
export const X = createIcon(XMarkIcon);
export const XCircle = createIcon(XCircleIcon);
export const Zap = createIcon(BoltIcon);
